// Public platform status — devolve flags non sensibles (beta mode,
// rexistro aberto). Usado pola landing para decidir se mostra a pantalla
// de "modo beta privado" cando o usuario non está autenticado.

import { apiClient } from './client';

export interface PlatformStatus {
  private_beta_mode: boolean;
  registration_open: boolean;
}

export async function getPlatformStatus(): Promise<PlatformStatus> {
  const { data } = await apiClient.get<PlatformStatus>('/api/v1/platform/status');
  return data;
}
